export default __webpack_public_path__ + "static/media/040-oven.01608bfb.svg";